module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alt":"Alternative text","remove":"Remove","generate":"Generate"}}')
  delete Component.options._Ctor
}
